import { ref, watch } from 'vue'

const STORAGE_KEY = 'timurka-user'

const userName = ref(localStorage.getItem(`${STORAGE_KEY}-name`) || '')
const userAvatar = ref(localStorage.getItem(`${STORAGE_KEY}-avatar`) || '')
const totalStars = ref(parseInt(localStorage.getItem(`${STORAGE_KEY}-stars`) || '0', 10))

const isProfileComplete = () => !!(userName.value && userAvatar.value)

watch(totalStars, (v) => {
  localStorage.setItem(`${STORAGE_KEY}-stars`, String(v))
})

export function useUserProfile() {
  function saveName(name) {
    userName.value = name
    localStorage.setItem(`${STORAGE_KEY}-name`, name)
  }

  function saveAvatar(dataUrl) {
    userAvatar.value = dataUrl
    localStorage.setItem(`${STORAGE_KEY}-avatar`, dataUrl)
  }

  function addStars(count) {
    totalStars.value += count
  }

  return {
    userName,
    userAvatar,
    totalStars,
    isProfileComplete,
    saveName,
    saveAvatar,
    addStars,
  }
}
